import promotionApi from "../api/promotion.api";
import { PromotionListResponse } from "../models/response/PromotionListResponse";
import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import errorModal from "../../../services/errorModal.service";

export const promotionService = {
    getPromotions: async (): Promise<UnifiedResponse<PromotionListResponse>> => {
        var response = await promotionApi.getPromotions();
        if (!response.isSuccess) {
            errorModal.showErrorModal(response.statusCode, response.message);
        }
        return response;
    },

    getPromotionByPageUrl: async (pageUrl: string): Promise<UnifiedResponse<PromotionListResponse>> => {
        var response = await promotionApi.getPromotionByPageUrl(pageUrl);
        if (!response.isSuccess) {
            errorModal.showErrorModal(response.statusCode, response.message);
        }
        return response;
    },
};

export default promotionService;
